import { Notification } from "../../../../models/Notification"
import { StoryId } from "../../../../models/Story"

export const MAP_NOTIFICATIONS_TO_STORIES = 'MAP_NOTIFICATIONS_TO_STORIES'
export const CLEAR_STORIES = 'CLEAR_STORIES'
export const OPEN_STORY = 'OPEN_STORY'
export const CLOSE_STORY = 'CLOSE_STORY'
export const NEXT_STORY = 'NEXT_STORY'
export const PREV_STORY = 'PREV_STORY'
export const GO_TO_STORY = 'GO_TO_STORY'
 
export interface MapNotificationsToStoriesAction {
    type: typeof MAP_NOTIFICATIONS_TO_STORIES,
    notifications: Notification[]
}

export const mapNotificationsToStories = (notifications: Notification[] = []): MapNotificationsToStoriesAction => {
    return {
        type: MAP_NOTIFICATIONS_TO_STORIES,
        notifications
    }
}

export interface GoToStoryAction {
    type: typeof GO_TO_STORY,
    id: number,
}

export const goToStory = (id: number): GoToStoryAction => ({
    type: GO_TO_STORY,
    id,
})

export interface ClearStoriesAction {
    type: typeof CLEAR_STORIES | 'FULL_RESET_STORE'
}

export const clearStories = (): ClearStoriesAction => ({
    type: CLEAR_STORIES
})

export interface OpenStoryAction {
    type: typeof OPEN_STORY,
    storyId: StoryId
}

export const openStory = (storyId: StoryId): OpenStoryAction => ({
    type: OPEN_STORY,
    storyId
})

export interface CloseStoryAction {
    type: typeof CLOSE_STORY
}

export const closeStory = (): CloseStoryAction => ({
    type: CLOSE_STORY,
})

export interface NextStoryAction {
    type: typeof NEXT_STORY
}

export const nextStory = (): NextStoryAction => ({
    type: NEXT_STORY,
})

export interface PrevStoryAction {
    type: typeof PREV_STORY
}

export const prevStory = (): PrevStoryAction => ({
    type: PREV_STORY,
})

export type StoriesActions = PrevStoryAction | NextStoryAction | CloseStoryAction | OpenStoryAction | ClearStoriesAction | MapNotificationsToStoriesAction | GoToStoryAction